import { styled } from '@planne-software/uni/mui/material';
import { Dialog } from '@planne-software/uni/Dialog';
import { modalActionsClasses, modalClasses, modalHeaderClasses } from '@planne-software/uni/Modal';
import { uni } from '@planne-software/uni/v2';

import { uniTypography } from '@src/fonts/typography/uniTypography';

// The widget renders inside the seller's page, so the theme's modal layer alone is not always above
// the host's own chrome. This is the lift the upsell modal and the seatmap already take.
const OVERLAY_LAYERS = 9999;

const actionsContent = `.${modalActionsClasses.root} > .${modalActionsClasses.content}`;

export const ErrorDialog = styled(Dialog)`
  z-index: ${({ theme }) => theme.zIndex.modal + OVERLAY_LAYERS};
  font-family: ${({ theme }) => theme.typography.fontFamily};

  && .${modalHeaderClasses.label} {
    padding-right: ${({ theme }) => theme.spacing(8)};
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    & .${modalClasses.content} {
      max-width: none;
    }
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    && .${modalClasses.content} {
      border-radius: ${uni('border-radius-xl')};
    }

    && .${modalHeaderClasses.root} {
      padding: ${uni('padding-content')};
      border-radius: ${uni('border-radius-xl')} ${uni('border-radius-xl')} 0 0;
    }

    && .${modalHeaderClasses.label} {
      ${uniTypography('text-lg', 'semibold')}
    }

    && ${actionsContent} {
      padding: 0 ${uni('padding-content')} ${uni('padding-content')};
      border-radius: 0 0 ${uni('border-radius-xl')} ${uni('border-radius-xl')};
    }

    && ${actionsContent} > :last-child {
      gap: ${uni('scale-300')};
    }
  }
`;
